import React from 'react';
import styles from './UnavailableState.module.css';

export default function UnavailableState({
  eyebrow = 'Unavailable',
  title,
  message,
  primaryLabel = 'Go Back',
  onPrimary,
  secondaryLabel,
  onSecondary,
}) {
  return (
    <div className={styles.wrap}>
      <div className={styles.card}>
        <span className={styles.eyebrow}>{eyebrow}</span>
        <h1>{title}</h1>
        <p>{message}</p>
        <div className={styles.actions}>
          {onPrimary ? <button type="button" className={styles.primaryButton} onClick={onPrimary}>{primaryLabel}</button> : null}
          {onSecondary ? <button type="button" className={styles.secondaryButton} onClick={onSecondary}>{secondaryLabel}</button> : null}
        </div>
      </div>
    </div>
  );
}
